// Module
var code = "<a href=\"#\" class=\"table_drill\">{{value}}</a>";
// Exports
export default code;